<template>
  <div class="modal" tabindex="-1" role="dialog" ref="modal">
    <div class="modal-background" @click="$emit('close')" />
    <div class="modal-dialog" :class="{'modal-lg': large}" role="document">
      <div class="modal-content">
        <div class="modal-header d-flex align-items-center" v-if="showHeader">
          <h5 class="modal-title">
            <slot name="title"></slot>
          </h5>
          <button type="button" class="close" aria-label="Close" v-if="showClose" @click="$emit('close')">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <slot name="body"></slot>
        </div>
        <div class="modal-footer" v-if="showFooter">
          <slot name="footer">
            <button type="button" class="btn btn-secondary" @click="$emit('close')">Close</button>
            <button type="button" class="btn btn-primary">Save changes</button>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    showHeader: {
      type: Boolean,
      default: true
    },
    showFooter: {
      type: Boolean,
      default: true
    },
    large: {
      type: Boolean,
      default: false
    },
    showClose: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      modal: null
    }
  }
}
</script>

<style scoped lang="scss">
.modal {
  display: block;
}
.modal-content {
  max-height: calc(100vh - 3.5rem);
}
.modal-body {
  overflow-y: auto;
}
.modal-header {
  background-color: $gray-200 !important;
}
.modal-header h5 {
  font-size: 1.3rem;
}
.modal-header .fas {
  color: $gray-600;
  font-size: 1rem !important;
}
.modal-background {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: $modal-backdrop-bg;
  opacity: 0.5;
}
</style>
